import { WorkspaceSmsSettingsIndexRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/actions/sms/')({
  component: WorkspaceSmsSettingsIndexRoute,
});
